import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // FIXED: No live user backend is hosted on Hostinger, so we bypass remote user states cleanly
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  // FIXED: Shortlists are now managed gracefully right in the visitor's local browser storage
  const [shortlist, setShortlist] = useState(() => {
    try {
      const saved = localStorage.getItem("radiance_shortlist");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  // FIXED: Saved searches are managed gracefully via local browser storage
  const [savedSearches, setSavedSearches] = useState(() => {
    try {
      const saved = localStorage.getItem("radiance_saved_searches");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  // Sync Shortlist to localStorage whenever it updates
  useEffect(() => {
    localStorage.setItem("radiance_shortlist", JSON.stringify(shortlist));
  }, [shortlist]);

  // Sync Saved Searches to localStorage whenever it updates
  useEffect(() => {
    localStorage.setItem("radiance_saved_searches", JSON.stringify(savedSearches));
  }, [savedSearches]);

  const loadShortlist = useCallback(async () => {}, []);
  const checkAuth = useCallback(async () => {}, []);

  const register = async () => {};
  const login = async () => {};
  const exchangeSession = async () => {};
  const logout = async () => {};
  const loginWithGoogle = () => {
    toast.info("Authentication system is offline. Using local anonymous session.");
  };

  // FIXED: Rewritten to save property favorites to LocalStorage seamlessly
  const toggleShortlist = async (property) => {
    const has = shortlist.includes(property.id);
    let updatedShortlist;
    if (has) {
      updatedShortlist = shortlist.filter(id => id !== property.id);
      toast.success(`${property.project || "Property"} removed from shortlist.`);
    } else {
      updatedShortlist = [...shortlist, property.id];
      toast.success(`${property.project || "Property"} saved to your shortlist.`);
    }
    setShortlist(updatedShortlist);
  };

  const sendShortlist = async (payload) => {
    toast.success("Shortlist processed successfully.");
    return { success: true };
  };

  const loadSavedSearches = useCallback(async () => {}, []);
  
  // FIXED: Save real estate filter preferences inside LocalStorage
  const saveSearch = async (payload) => {
    const mockSearch = {
      id: "search_" + Math.random().toString(36).substr(2, 9),
      created_at: new Date().toISOString(),
      alerts: false,
      ...payload
    };
    setSavedSearches((prev) => [mockSearch, ...prev]);
    toast.success("Search filters saved locally.");
    return mockSearch;
  };

  const toggleSearchAlerts = async (s) => {
    toast.info("Email alerts require an active database server backend connection.");
  };

  const deleteSearch = async (s) => {
    setSavedSearches((prev) => prev.filter((x) => x.id !== s.id));
    toast.success("Saved search filters removed.");
  };

  const toggleDigest = async () => {
    toast.info("Newsletter digest subscriptions require an active server database backend connection.");
  };

  const value = useMemo(
    () => ({ 
      user, loading, shortlist, authOpen, setAuthOpen, register, login, logout, 
      loginWithGoogle, exchangeSession, toggleShortlist, sendShortlist, checkAuth, 
      savedSearches, loadSavedSearches, saveSearch, toggleSearchAlerts, deleteSearch, toggleDigest 
    }),
    [user, loading, shortlist, authOpen, savedSearches]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
